import React, { lazy } from 'react'
import { Route } from 'react-router-dom'

const List = lazy(() => import('../modules/Competitions').then(m => ({ default: m.CompetitionList })))
const Create = lazy(() => import('../modules/Competitions').then(m => ({ default: m.CompetitionCreate })))
const Edit = lazy(() => import('../modules/Competitions').then(m => ({ default: m.CompetitionEdit })))
const Preview = lazy(() => import('../modules/Competitions').then(m => ({ default: m.CompetitionPreview })))
const Analytics = lazy(() => import('../modules/Competitions').then(m => ({ default: m.CompetitionAnalytics })))
const Accept = lazy(() => import('../modules/Competitions').then(m => ({ default: m.AcceptCompetition })))

export const competitionRoutes = [
  <Route key='comp-list' path='/profile/competitions' element={<List />} />,
  <Route key='comp-create' path='/profile/competitions/create' element={<Create />} />,
  <Route key='comp-edit' path='/profile/competitions/:competitionId' element={<Edit />} />,
  <Route key='comp-preview' path='/profile/competitions/:competitionId/preview' element={<Preview />} />,
  <Route key='comp-analytics' path='/profile/competitions/:competitionId/analytics' element={<Analytics />} />,
  <Route
    key='comp-accept'
    path='/competitions/accept'
    element={<Accept />}
  />
]
